import styles from "./context-menu-item.module.css";
import React, { ReactNode } from "react";

export type ContextMenuItemProps = {
  as?: any;
  children: ReactNode;
} & Record<string, any>;

export function ContextMenuItem({
  as = "div",
  children,
  ...props
}: ContextMenuItemProps) {
  return React.createElement(
    as,
    {
      className: styles.Item,
      ...props,
    },
    children
  );
}
